import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { type Theme } from "@mui/material/styles";
import { type ReactNode } from "react";

interface Props {
  children: ReactNode;
  theme: Theme;
}

export const ThemeProvider = (props: Props) => <MuiThemeProvider {...props} />;
